module.exports = __webpack_public_path__ + "static/media/background_1920px_WEBP.9a041bbb.webp";